import { gql } from "@apollo/client";
import { SubCardDataFragment } from "lib/graphql-generated";
import Link from "next/link";
import { Button } from "./buttons/button";
const SUB_CARD_FRAGMENT = gql`
  fragment SubCardData on subscriptions {
    id
    slug
    title
    image
  }
`;

interface Props {
  sub: SubCardDataFragment;
  className?: string;
}
export const SubCard = ({ sub, className }: Props) => {
  return (
    <article
      className={`group flex flex-col max-w-2xs ${className} cursor-pointer`}>
      <Link href={`/shop/subscriptions/${sub.slug}`}>
        <a className='flex flex-col flex-1'>
          <img
            src={sub.image}
            alt={`Image for ${sub.title}`}
            className='group-hover:-translate-y-1 transform ease-in transition-transform min-h-60 bg-green-light text-white'
          />
          <header className='pt-4 mt-auto'>
            <h1 className='header text-xl group-hover:text-red-dark'>
              {sub.title}
            </h1>
          </header>
        </a>
      </Link>
      <section className='flex flex-row flex-wrap  border-gray-300  justify-end'>
        <hr className='bg-gray-300 w-full h-4 mb-2 ' />
        <Button buttonType='primary' href={`/shop/subscriptions/${sub.slug}`}>
          View
        </Button>
      </section>
    </article>
  );
};
